<script setup lang="ts">
import type { VoixColorFieldInterface, VoixTextFieldInterface, VoixWysiwygFieldInterface } from '@voix/types'

defineProps<{
  inView: boolean
  fields: {
    subtitle: VoixTextFieldInterface
    title: VoixTextFieldInterface
    titleColor: VoixColorFieldInterface
    text: VoixWysiwygFieldInterface
    footer: VoixTextFieldInterface
    footerColor: VoixColorFieldInterface
  }
}>()

defineSlice({
  name: { label: 'Blue Project Title & Copy', group: 'Blue Project', layouts: ['BlueProject'] },
  description: 'Title with Subtitle and optional copy',
  preview: 'SlicesBlueProjectTitleCopy.jpg',
  fields: {
    subtitle: {
      label: 'Subtitle',
      type: 'text',
      enabled: false,
    },
    subtitleColor: {
      label: 'Subtitle Color',
      type: 'color',
      default: '#31BAD6',
    },
    title: {
      label: 'Title',
      type: 'text',
    },
    titleColor: {
      label: 'Title Color',
      type: 'color',
    },
    text: {
      label: 'Copy',
      type: 'wysiwyg',
      enabled: false,
    },
    footer: {
      label: 'Footer',
      type: 'text',
      enabled: false,
    },
    footerColor: {
      label: 'Footer Color',
      type: 'color',
    },
  },
  templates: [{
    label: 'Main Example',
    fields: {
      subtitle: {
        value: 'Subtitle',
      },
      title: {
        value: 'Title',
      },
      text: {
        value: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam nec purus nec libero ultricies ultricies. Nullam nec purus nec libero ultricies ultricies.</p>',
      },
    },
  }],
})
</script>

<template>
  <div class="flex justify-center pt-16 pb-24 text-center title-copy">
    <div class="container">
      <div>
        <div
          v-if="fields.subtitle.enabled"
          class="text-lg sm:text-2xl tracking-widest text-white font-bold duration-700"
          :class="{ 'opacity-0 translate-y-12': !inView }"
          :style="{ color: fields.subtitleColor.value }"
        >
          {{ fields.subtitle.value }}
        </div>
        <div
          class="font-bold text-2xl sm:text-4xl tracking-wide duration-700 delay-300"
          :class="{ 'opacity-0 translate-y-12': !inView }"
          :style="{ color: fields.titleColor.value }"
        >
          {{ fields.title.value }}
        </div>
      </div>

      <VoixWysiwyg class="text-lg font-light duration-700 delay-500 my-4 max-w-[984px] mx-auto text-sm sm:text-base" :class="{ 'opacity-0 translate-y-12': !inView }" :field="fields.text" />

      <div
        v-if="fields.footer.enabled"
        class="text-2xl tracking-wide duration-700 delay-700"
        :class="{ 'opacity-0 translate-y-12': !inView }"
        :style="{ color: fields.footerColor.value }"
      >
        {{ fields.footer.value }}
      </div>
    </div>
  </div>
</template>
